/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { ticketColors } from '../theme/public-api';

type Props = {
  onPress: () => void;
  label?: string;
  accessibilityLabel?: string;
};

export function OperationalFilterClearLink({
  onPress,
  label = 'Borrar',
  accessibilityLabel = 'Borrar filtros',
}: Props) {
  return (
    <TouchableOpacity onPress={onPress} accessibilityRole="button" accessibilityLabel={accessibilityLabel}>
      <Text style={{ fontSize: 13, fontWeight: '700', color: ticketColors.gold }}>{label}</Text>
    </TouchableOpacity>
  );
}
